import { addFavorite as _addFavorite, delFavorite as _delFavorite } from "./favorite"
import {
	getFuturesData,
	getLBMAPrices,
	getProductList,
	getSpotOverseasExchangeRate,
	getSpotOverseasIndex,
} from "./markets"

export type { IExchangeRateData, IFuturesData, IIndexData, ILBMAPricesResponse, ProductListResponse } from "./interface"
export { getFuturesData, getLBMAPrices, getProductList, getSpotOverseasExchangeRate, getSpotOverseasIndex }

const CATEGORY_SPOT = "spot_en"

/**
 * 添加收藏（与 www 站 spotoverseascenter 一致）
 */
export async function addFavorite(productId: string) {
	return _addFavorite(productId, CATEGORY_SPOT)
}

/**
 * 取消收藏
 */
export async function delFavorite(productId: string) {
	return _delFavorite(productId, CATEGORY_SPOT)
}
